module.exports = {
    sanity: {
      projectId: process.env.GATSBY_SANITY_PROJECT_ID || "5pmt1um7",
      dataset: process.env.GATSBY_SANITY_DATASET || "production",
    }
  };
  